// Bet actions
export const SELECT_RACING_BET_TYPE = 'SELECT_RACING_BET_TYPE';
export const TOGGLE_MULTI_BET_RACER_SELECTION = 'TOGGLE_MULTI_BET_RACER_SELECTION';
export const TOGGLE_RACE_CARD_SORT_FIELD_SELECTION = 'TOGGLE_RACE_CARD_SORT_FIELD_SELECTION';
export const CLEAR_MULTI_BET_RACER_SELECTION = 'CLEAR_MULTI_BET_RACER_SELECTION';



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/constants/actionTypes.js